<script>
export default {
  props: [
    'id',
    'inverse'
  ],

  computed: {
    cloneUrl: function () {
      return Labstack.url + '/topologies/' + this.id + '/clone'
    }
  }
}
</script>

<template>
  <a class="btn click-prevent"
    :href="cloneUrl"
    :class="{ 'btn-primary': !inverse, 'btn-inverse btn-outline': inverse }"
  >
    <i class="fa fa-files-o"></i>&nbsp;&nbsp;
    Duplicate
  </a>
</template>
